import queryCache from 'data/cache';
import { Order } from 'model/orders';

export const setIsUpdatingOrderStatus = (
  orderId: string,
  isUpdatingStatus: boolean,
) => {
  const currentOrders = queryCache.getQueryData<Order[]>('orders') || [];

  const ordersUpdated = currentOrders.map((order) => ({
    ...order,
    isUpdatingStatus:
      order.id === orderId ? isUpdatingStatus : order.isUpdatingStatus,
  }));

  queryCache.setQueryData('orders', ordersUpdated);
  queryCache.invalidateQueries('orders');
};

export const markOrderAsSeen = (orderId: string) => {
  const currentOrders = queryCache.getQueryData<Order[]>('orders') || [];

  const ordersUpdated = currentOrders.map((order) => ({
    ...order,
    unseen: order.id === orderId ? false : order.unseen,
  }));

  queryCache.setQueryData('orders', ordersUpdated);
  queryCache.invalidateQueries('orders');
};

export const addOrUpdateOrder = (newOrder: Order) => {
  const currentOrders = queryCache.getQueryData<Order[]>('orders') || [];
  let alreadyCache = false;
  let ordersUpdated = [];

  ordersUpdated = currentOrders.map((order) => {
    if (order.id === newOrder.id) {
      alreadyCache = true;
      return newOrder;
    }
    return order;
  });

  if (alreadyCache) {
    queryCache.invalidateQueries(['order', newOrder.id]);
  } else {
    ordersUpdated = [newOrder, ...ordersUpdated];
  }

  queryCache.setQueryData('orders', ordersUpdated);
};
